import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const KeyIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.7266 11.614C1.47654 11.864 1.33601 12.2031 1.33594 12.5567V14.0047C1.33594 14.1815 1.40618 14.351 1.5312 14.4761C1.65622 14.6011 1.82579 14.6713 2.0026 14.6713H4.0026C4.17941 14.6713 4.34898 14.6011 4.47401 14.4761C4.59903 14.351 4.66927 14.1815 4.66927 14.0047V13.338C4.66927 13.1612 4.73951 12.9916 4.86453 12.8666C4.98956 12.7416 5.15913 12.6713 5.33594 12.6713H6.0026C6.17941 12.6713 6.34898 12.6011 6.47401 12.4761C6.59903 12.351 6.66927 12.1815 6.66927 12.0047V11.338C6.66927 11.1612 6.73951 10.9916 6.86453 10.8666C6.98956 10.7416 7.15913 10.6713 7.33594 10.6713H7.4506C7.8042 10.6713 8.14328 10.5307 8.39327 10.2807L8.93594 9.738C9.86249 10.0608 10.8712 10.0595 11.7969 9.7345C12.7227 9.40947 13.5107 8.77989 14.0322 7.94875C14.5536 7.11761 14.7775 6.13411 14.6673 5.15916C14.5571 4.1842 14.1193 3.2755 13.4256 2.58171C12.7318 1.88792 11.8231 1.45012 10.8481 1.33992C9.87316 1.22973 8.88966 1.45366 8.05852 1.97509C7.22738 2.49652 6.5978 3.28458 6.27277 4.21034C5.94774 5.13611 5.94651 6.14477 6.26927 7.07133L1.7266 11.614Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 6C10.7761 6 11 5.77614 11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

KeyIcon.displayName = 'KeyIcon';
